import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Overview from './Overview';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data, overview } = state.dashboard;
  return {
    isLoading,
    data,
    overview,
  };
}

const Styled = withStyles(styles)(Overview);

export default connect(
  mapStateToProps,
)(Styled);
